<ng-container *ngIf="!multiple_upload" class="cameraIcon">
  <div class="avatar-img">
    <img *ngIf="avatarImg" alt="avatar" [src]="avatarImg " (click)="showImageDialog(avatarImg)">
    <div class="row screen-lg m-y-15">
      <div class="col-6 col-md-6">
        <div class="upload-card" (click)="avater.click()">
          <div class="upload-card-icon">
            <span class="material-icons">perm_media</span>
          </div>
          <span class="upload-card-text">{{"COMMON.PLEASE_SELECT_FILE" | translate}}</span>
        </div>
        <input type="file" #avater (change)="onSelectAvatarFile($event,avater)" accept="image/*"
          [multiple]="multiple_upload" hidden>
      </div>
      <div class="col-6 col-md-6">
        <div class="upload-card camera-card" (click)="openCameraDialog();">
          <div class="upload-card-icon">
            <span class="material-icons">add_a_photo</span>
          </div>
          <span class="upload-card-text">{{"COMMON.CAMERA" | translate}}</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="multiple_upload" class="cameraIcon">
  <div>
    <div class="row upload-section">
      <div class="upload-cards-container">
        <div class="row" id="small-row">
          <div class="col-md-6 col-sm-6">
            <div class="upload-card" (click)="input.click()">
              <div class="upload-card-icon">
                <span class="material-icons">perm_media</span>
              </div>
              <span class="upload-card-text">{{"COMMON.PLEASE_SELECT_FILE" | translate}}</span>
            </div>
            <input type="file" (change)="onSelectFileChange($event)" #input accept="image/*"
              [multiple]="multiple_upload" hidden>
          </div>
          <div class="col-md-6 col-sm-6">
            <div class="upload-card camera-card" (click)="openCameraDialog();">
              <div class="upload-card-icon">
                <span class="material-icons">add_a_photo</span>
              </div>
              <span class="upload-card-text">{{"COMMON.CAMERA" | translate}}</span>
            </div>
          </div>
        </div>

        <div class="selected-files-info" *ngIf="selectFiles.length !== 0">
          <span class="material-icons info-icon">check_circle</span>
          <span class="info-text">{{ "COMMON.SELECTED_FILES_NUMBER_IS" | translate}} {{selectFiles.length}}</span>
        </div>
        <button class="upload-btn" mat-fab color="primary" *ngIf="uploadButton"
          [disabled]="disabled && selectFiles.length === 0" type="button" (click)="uploadFiles()">
          <span class="material-icons">backup</span>
        </button>
      </div>
    </div>
    <div class="divider"></div>
    <div>
      <div class="itemAttachImg" *ngFor="let attachImage of attachments">

        <img [src]="imgUrl + attachImage.imagePath" alt="" (click)="showImageDialog(imgUrl + attachImage.imagePath)" />
        <span class="material-icons" [matMenuTriggerFor]="menu">
          settings_applications
        </span>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="deleteItemAttach(attachImage)">
            <mat-icon>delete</mat-icon>
            <span>{{ "COMMON.REMOVE" | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>

</ng-container>